export default __webpack_public_path__ + "static/officeIcon-359669dd1d6128ee9aacb5dc761c909c.svg";